/**
 * LocationVenueRequestService
 * Service for LocationVenueRequest entity operations
 * Route: api/locationvenuerequests
 * Controller: LocationVenueRequestsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * LocationVenueRequestService
 * Handles location venue request CRUD operations
 * Maps to /api/locationvenuerequests endpoint
 */
export class LocationVenueRequestService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? LocationVenueRequestService.DEFAULT_SERVICE_PATH,
            basePath: LocationVenueRequestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
LocationVenueRequestService.DEFAULT_SERVICE_PATH = 'meetings';
LocationVenueRequestService.BASE_PATH = 'api/locationvenuerequests';
//# sourceMappingURL=LocationVenueRequestService.js.map